import axios from '@/common/axios'
import {
  XYGL
} from '../constants/funcUrl'

/**
 * 运营管理
 */
const xyglAction = {
  // 学员我的学习列表
  getMyStudys: ({
    commit
  }, params) => {
    return axios.getAsync(commit, XYGL.MYSTUDY, params);
  },
  // 在线学习详情
  getMyStudysDetails: ({
    commit
  }, params) => {
    return axios.getAsync(commit, XYGL.MYSTUDYDETAILS, params);
  },
  // 在线学习课时详情
  getMyStudyLessonDetails: ({
    commit
  }, params) => {
    return axios.getAsync(commit, XYGL.MYSTUDYLESSONDETAILS, params);
  },
  // 更新课时学习进度
  putUpdateProgress: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, XYGL.UPDATEPROGRESS, params);
  },
  // 更新课时学习进度
  putCompleteProgress: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, XYGL.COMPLETEPROGRESS, params);
  },
  // 获取课后练习题目
  getPosttestQuestions: ({
    commit
  }, params) => {
    return axios.getAsync(commit, XYGL.POSTTESTQUESTION, params);
  },
  // 提交课后练习答案
  postSubMitPosttest: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, XYGL.SUBMITPOSTTEST, params);
  },
  // 获取完课考试题目
  getCourseExamQuestions: ({
    commit
  }, params) => {
    return axios.getAsync(commit, XYGL.COURSEEXAMQUESTION, params);
  },
  // 提交完课考试答案
  postSubmitCourseexam: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, XYGL.SUBMITCOURSEEXAM, params);
  },
  // 提交人脸检测
  postStudyFacecheck: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, XYGL.STUDYFACECHECK, params);
  },
  // 提交人脸录屏
  postStudyFaceVideo: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, XYGL.STUDYFACEVIDEO, params);
  },
  // 查询完课证书信息
  getCertLearncert: ({
    commit
  }, params) => {
    return axios.getAsync(commit, XYGL.CERTLEARNCERT, params);
  },
  // 学员查看自己的个人资料接口
  getEmployeePersonaLprofile: ({
    commit
  }, params) => {
    return axios.getAsync(commit, XYGL.EMPLOYEEPERSONALPROFILE, params);
  }

}

export default xyglAction;



// WEBPACK FOOTER //
// ./src/store/jzjy/actions/xyglAction.js